<template>
  <div
    class="w-full flex flex-wrap sm:flex-nowrap justify-between items-center h-fit max-w-7xl py-4 px-6 mx-auto gap-3 border-t lg:border-t-0"
  >
    <div class="flex flex-col gap-2 text-white text-xs gap-2 w-full sm:w-auto">
      <span class="text-center sm:text-left"
        >© {{ new Date().getFullYear() }} Schooled Elections Manager.</span
      >

      <a
        :href="LINKS.HAIL"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Hail (opens in a new tab)"
        class="mb-1 flex justify-center sm:justify-start"
      >
        <img
          src="/img/logo/hail-logo-white.png"
          alt="Created by Hail"
          width="120"
        />
      </a>
    </div>

    <div class="flex flex-col gap-2 text-white text-xs w-full sm:w-auto">
      <span class="text-center sm:text-right">
        0800 VOTENZ (0800 868 369)
      </span>

      <div
        class="flex flex-row justify-center items-center sm:justify-end gap-1"
      >
        <ModalElectionPrivacy>
          <template #trigger>
            <a class="brand__link--white-secondary text-xs">Privacy Policy</a>
          </template>
        </ModalElectionPrivacy>
        |
        <ModalElectionTerms>
          <template #trigger>
            <a class="brand__link--white-secondary text-xs">Terms</a>
          </template>
        </ModalElectionTerms>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalElectionTerms from '../../../components/modal/ModalElectionTerms.vue'
import ModalElectionPrivacy from '../../../components/modal/ModalElectionPrivacy.vue'
import { LINKS } from '../../../constants.js'

export default defineComponent({
  name: 'PageFooter',

  components: {
    ModalElectionTerms,
    ModalElectionPrivacy,
  },

  setup() {
    return {
      LINKS,
    }
  },
})
</script>
